import { t } from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionLink from '../components/ActionLink';
import YesNoDialog from '../components/YesNoDialog';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import UserCategoryService from '../services/UserCategoryService';
import UserCategoryEditDialog from './UserCategoryEditDialog';
import IconColorComponent from '../components/inputs/IconColorComponent';

class UserCategoryListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new UserCategoryService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusOptions: [],
            roleTypeOptions: [],
            dialogVisibile: false,
            deleteConfirmDialogVisible: false,
            element: this.initNewElement(),
        };
        this.handleOpenNewDialog = this.handleOpenNewDialog.bind(this);
    }

    initNewElement(){
        return {
            name: '',                
                status: {enumValue: 'ACTIVE', label: 'Aktywny'},
            color:'',    
            icon:'',    
        }
    }

    updateSearchCriteria(criteria) {
        return {
            name: criteria.login,          
            status: criteria.status,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            name: '',            
            status: {enumValue: 'ACTIVE', label: 'Aktywny'},
            id: null,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
        };
    }

    initializeFromBackend() {
        this.enumService
            .getEnumList('UserCategoryStatus')
            .then((statusOptions) =>
                this.setState({
                    statusOptions,
                })
            )
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy statusów');
            });
    }

    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='name'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.name}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={'Nazwa'}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />                
               
                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={'Status'}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.status}
                    options={this.state.statusOptions}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    filterOptionValue='label'
                    refreshFromBackend
                />
            </div>
        );
    }
    enumTemplate(field, rowData) {
        if (rowData[field] && rowData[field].label) {
            return rowData[field].label;
        } else if (rowData[field]) {
            return rowData[field];
        }
        return '';
    }

    actionTemplate(rowData) {
        return (
            <span>
            <ActionLink
                iconName='mdi-pencil'
                iconSide='left'
                iconSize='icon-large'
                handleClick={(e) => this.handleOpenEditDialog(e, rowData)}
                variant='blue'
                className='edit-blue-link'
                key={'view-button'}
                rendered={rowData.status.enumValue ==='ACTIVE'}
            />
           <ActionLink
                 iconName='mdi-delete'
                 iconSide='left'
                 iconSize='icon-large'
                handleClick={(e) => this.handleOpenDeleteDialog(e, rowData)}
                variant='blue'
                className='edit-blue-link'
                key={'delete-button'}
                rendered={rowData.status.enumValue ==='ACTIVE'}
            />
           </span>
        );
    }

    handleOpenEditDialog(e, rowData) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: this.cloneElement(rowData), dialogViewMode: 'EDIT'});
    }

    handleOpenDeleteDialog(e, rowData) {
        if (e) {
            e.preventDefault();
        }
        this.setState({deleteConfirmDialogVisible: true, element: rowData, dialogViewMode: 'DELETE'});
    }

    prepareColumns() {
        const result = [
            {field: 'name', header: 'Nazwa', sortable: true},                        
            {field: 'status', header: 'Status', sortable: true, body: this.enumTemplate.bind(this, 'status')},
            {field: 'color.value', header: 'Ikona',  body: this.iconComponent},                        
            
        ];
        if (this.authService.isUserInRole('ROLE_USER_CATEGORY_EDIT')) {
            result.push({
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action',
            });
        }
        return result;

    }
    iconComponent(rowData){
        return <div style={{marginTop:"1px", marginBottom:"-6px"}}><IconColorComponent   icon={rowData.icon.value} color={rowData.color.value} /></div>
    }

    prepareHeaderItems() {
        return this.authService.isUserInAnyRole('ROLE_USER_CATEGORY_EDIT')
            ? [
                  {
                      label: t('employeeCategory.newButton'),
                      type: 'BUTTON',
                      className: 'float-right',
                      variant: 'blue',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                      iconColor: 'white',
                      onClick: this.handleOpenNewDialog,
                  },
              ]
            : [];
    }
    handleOpenNewDialog(e) {
        let basicElement = this.initNewElement();       
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: basicElement, dialogViewMode: 'NEW'});
    }

    handleDelete(e){
        if (e) {
            e.preventDefault();
        }
        console.log('delete {}', this.state.element)              
        this.service
            .remove(this.state.element)
            .then((response) => {
                this.blockUi();
                this.persistMessage('success', '', t('employeeCategory.deleteSuccess'));
            })
            .catch((err) => {
                this.persistMessage('error', '', t('employeeCategory.deleteError'));               
            })
            .finally(() => {
                this.afterObjectUpdate();
                this.setState({deleteConfirmDialogVisible: false});
            });
        
    }

    afterObjectUpdate() {       
        this.readMessage();
        this.refreshTable();
        this.unblockUi();
    }

    render() {
        return (
            <div className='container-fluid employeecategory-list'>
                <BreadcrumbsItem to='/employeecategory-list'>{'Kategorie pracownika'}</BreadcrumbsItem>
                {this.renderView()}
                {this.state.dialogVisibile ? (
                    <UserCategoryEditDialog
                        className='employeecategory-dialog'
                        key={`employeecategory-dialog-${this.state.element?.id}`}
                        element={this.state.element}
                        onHide={(e) => this.setState({dialogVisibile: false})}
                        visible={this.state.dialogVisibile}
                        viewMode={this.state.dialogViewMode}                        
                        afterSave={(e) => {
                            this.setState({dialogVisibile: false});
                           this.afterObjectUpdate();
                        }}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                    />
                ) : null}
                {this.state.deleteConfirmDialogVisible ? (
                <YesNoDialog
                    visible={this.state.deleteConfirmDialogVisible}
                    header={t('employeeCategory.deleteHeader')}
                    name='visible'
                    onChange={(type, x, target) => {
                        if (target.value) {
                        
                            this.handleDelete();
                        } else {
                            this.setState({deleteConfirmDialogVisible: false})
                        }
                    }}
                    onHide={() => this.setState({deleteConfirmDialogVisible: false})}
                     >
                        {t('details.deleteConfirmation')+'\n' + this.state.element.name}
                    </YesNoDialog> 
                ) : null}
            </div>
        );
    }
}

UserCategoryListContainer.defaultProps = {
    detailUrl: '/#/user-category/details',
    newUrl: '/#/user-category/create',
    lazy: true,
};

UserCategoryListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default UserCategoryListContainer;
